/** Login may resume a Support email link, never an arbitrary redirect target. */
export function getSupportReturnPath(value: unknown): string | null {
  if (typeof value !== 'string' || !value.startsWith('/support')) return null;
  try {
    const url = new URL(value, 'https://support.invalid');
    if (url.origin !== 'https://support.invalid' || !/^\/support(?:\/(?:faq|guides(?:\/[a-z0-9-]+)?))?$/.test(url.pathname)) return null;
    const params = new URLSearchParams();
    const thread = url.searchParams.get('thread');
    if (thread && /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(thread)) params.set('thread', thread);
    if (url.searchParams.get('view') === 'submitted') params.set('view', 'submitted');
    const query = params.toString();
    return `${url.pathname}${query ? `?${query}` : ''}`;
  } catch {
    return null;
  }
}
